import { Link } from '@gravity-ui/uikit';

import { Container } from '../ui-kit';

import { ANY_QUESTIONS, EMAIL, RESEARCH, YEAR } from './constants';

import { ReactComponent as LogoImg } from 'assets/images/logo.svg';

import { useMediaQuery } from 'react-responsive';

import { ReactComponent as LogoITFB } from '../../assets/images/icon-itfb-chb.svg';
import { ReactComponent as LogoITFB2 } from '../../assets/icons/itfb_logo.svg';
import { ReactComponent as LogoGameFond } from '../../assets/icons/fond_game_icon.svg';

import styles from './styles.module.scss';
import { Box } from '@mui/material';

interface FooterProps {
	loggedIn?: boolean;
}

export const Footer = ({ loggedIn }: FooterProps) => {
	const isExact768 = useMediaQuery({ query: '(max-width: 768px)' });
	return (
		<footer className={`${styles.footer} ${loggedIn && styles.loggedIn}`}>
			{isExact768 ? (
				<Container className={`${styles.footer__container} `}>
					<div className={`${styles.footer__logo} ${loggedIn && styles.loggedIn}`}>
						{loggedIn && (
							<Link href="" className={styles.footer__logo__research}>
								{RESEARCH}
							</Link>
						)}

						{loggedIn && (
							<div className={styles.footer__info}>
								<p>
									{ANY_QUESTIONS}{' '}
									<Link href="mailto:edu@fond-igra.ru" className={styles.footer__info__link}>
										{EMAIL}
									</Link>
								</p>
							</div>
						)}

						<div className={styles.footer__logo__img}>
							<LogoImg />

							<p className={styles.footer__logo__year}>{YEAR}</p>
						</div>
						<div className={styles.footer__container__logo_company}>
							<p>Разработано</p> <LogoITFB />
						</div>
					</div>
				</Container>
			) : (
				<Container className={styles.footer__container}>
					<div></div>
					{loggedIn && (
						<div className={styles.footer__info}>
							<p>
								{ANY_QUESTIONS}{' '}
								<Link href="mailto:edu@fond-igra.ru" className={styles.footer__info__link}>
									{EMAIL}
								</Link>
							</p>
						</div>
					)}
					<div className={styles.footer__container__logo_company}>
						<LogoITFB2 />
						<LogoGameFond />
					</div>
				</Container>
			)}
		</footer>
	);
};
